module.exports = "/images/SS-logo.png?0983f8a3cc395744ab402899546ac983";